const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ2: {
				name: ['(客製)報表', '(客製)報表', '(客製)報表'],
				children: {					
					ZZ_FLORIDABAKERY_AM: {
						name: ['出勤核對表', '出勤核對表', '出勤核對表'],
						url: '/zz_floridabakery_am',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
	
};